import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { getDatabase, ref, get } from 'firebase/database';

const UserVerification = () => {
  const navigate = useNavigate();
  const auth = getAuth();
  const db = getDatabase();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const userRef = ref(db, `blackstone-users/${user.uid}`);
          const snapshot = await get(userRef);

          if (!snapshot.exists()) {
            await signOut(auth);
            navigate('/');
          }
        } catch (error) {
          console.error("Error verifying user in database:", error);
          await signOut(auth);
          navigate('/');
        }
      } else {
        navigate('/');
      }
    });

    return () => unsubscribe();
  }, [auth, db, navigate]);
};

export default UserVerification;
